import { ContentCopyIcon, IconButton, Menu, MenuItem } from "@firecms/ui";

export type CopyOption = { label: string; value: string | undefined };

export const CopyMenu = ({ options }: { options: CopyOption[] }) => {
  const available = options.filter((o) => o.value);
  if (available.length === 0) return null;

  return (
    <Menu
      trigger={
        <IconButton size="smallest">
          <ContentCopyIcon size="smallest" />
        </IconButton>
      }
      align="end"
    >
      {available.map((opt) => (
        <MenuItem key={opt.label} dense onClick={() => navigator.clipboard.writeText(opt.value!)}>
          <div className="flex flex-col gap-0.5 py-0.5">
            <span className="text-xs text-text-secondary dark:text-text-secondary-dark uppercase tracking-wide">
              {opt.label}
            </span>
            <span className="font-mono text-xs max-w-56 truncate">{opt.value}</span>
          </div>
        </MenuItem>
      ))}
    </Menu>
  );
};
